module.exports = __webpack_public_path__ + "static/media/switchIcon.adec51d1.svg";